import React, { Component } from 'react';

class _404 extends Component {
    constructor () {
        super();
        this.fireRedirect = this.fireRedirect.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
    }
    
    componentDidMount () {
    }
    
    handleRedirect(url) {
        this.props.history.push(url);
    }
    
    fireRedirect(e) {
        e.preventDefault()
        this.handleRedirect(e.currentTarget.getAttribute('href'));
    }
    
    render () {
        return (
            <div className="wrapper">
                <div id="content">
                    <main>
                        <div className="position-absolute h-100 w-100 m-0 d-flex align-items-center justify-content-center">
                            <div className="mx-auto" id="login_container">
                                <div className="card p-5">
                                    <div className="card-body">
                                        <h3 className="text-center">ページが見つかりませんでした</h3>
                                        <figure className="mb-5 text-center">
                                            <img src="/img/404.png" height="120" />
                                        </figure>
                                        <p>
                                            ページが見つかりませんでした。<br />
                                            お探しのページはいずれかの理由により見つかりませんでした<br />
                                            ページのURLが変更された可能性があります。<br />
                                            ページが削除された可能性があります。<br />
                                            アドレス（URL）をタイプミスしている可能性があります。<br />
                                            <br />
                                            <strong>解決方法</strong><br />
                                            URLが正しく入力されているかご確認ください。<br />
                                            ご意見・ご質問・不具合報告はお問い合わせください。
                                        </p>
                                        <a href="/houjin/home" className="btn btn-warning btn-lg btn-block">ダッシュボードへ戻る</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>
                </div>
            </div>
        );
    }
}
export default _404;